module.exports = __webpack_public_path__ + "static/media/poc-pokerlistings.edb343be.svg";